<!--
브라우저 > 로컬스토리지에 저장되는 세팅정보
지역을 구분하지 않고, 작업PC 별로 설정정보를 기록한다.
같은PC에서 다른사용자 로그인해도 같은 설정 적용
-->
<template>
    <div class="root">

        <!-- 설정창 -->
        <div ref="modal" class="uk-flex-top" uk-modal="stack: true" esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h3>업로드 설정</h3>
                </div>
                <div class="uk-modal-body">
                    <label class="uk-text-large">
                        <input type="checkbox" class="uk-checkbox" v-model="editedSettings.onAddWebcam" />
                        웹캠촬영
                    </label>
                    <div class="uk-text-large uk-margin-large-left">
                        <app-input-ex
                            type="radio"
                            v-model="editedSettings.webcamWidth"
                            :options="[{text: 'HD(720p)', val: '1312'},{text: 'FHD(1080p)', val: '1920'},{text: 'QHD(1440p)', val: '2560'},{text: 'UHD(2160p)', val: '3840'}]"
                        >
                        </app-input-ex>
                        <div class="uk-text-danger"> * 웹캠에서 지원하는 화질을 선택</div>
                    </div>

                    <label class="uk-text-large">
                        <input type="checkbox" class="uk-checkbox" v-model="editedSettings.onAddPhone" />
                        스마트폰촬영
                    </label>
                    <label class="uk-text-large">
                        <input type="checkbox" class="uk-checkbox" v-model="editedSettings.onAddLocal" />
                        파일추가(로컬업로드)
                    </label>
                    <label class="uk-text-large">
                        <input type="checkbox" class="uk-checkbox" v-model="editedSettings.onAddUrl" />
                        URL추가
                    </label>

                </div>

                <div class="uk-modal-footer uk-text-center">
                    <button
                        type="button"
                        class="uk-button uk-button-large uk-button-white uk-margin-right"
                        @click="closeSettingModal"
                    >
                        <i class="material-icons">close</i>
                        취소
                    </button>

                    <button
                        type="button"
                        class="uk-button uk-button-large uk-button-primary"
                        @click="save"
                    >
                        <i class="material-icons">check</i>
                        저장
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * 세팅 기본값(로컬스토리지에 설정된값이 없을경우 적용될 세팅)
         * 기본설정되야하는 일부 항목만 설정가능
         */
        defaultSettings: {
            type: Object,
            default: () => {
                return {};
            },
        },

        /**
         * 촬영세션 용 현재 사용자 ID
         */
        sessionOwner: {
            type: Number,
            default: null
        },
    },
    data: function () {
        let defaults = {
            // (string) 화질  (1312: hd 720p, 1920: fhd 1080p, 2560: qhd 1440p, 3840: uhd 2160p)
            webcamWidth: 1920,

            // (bool) 웹캠 촬영기능 ON
            onAddWebcam: false,
            // (bool) 스마트폰 촬영기능 ON
            onAddPhone: true,
            // (bool) 파일추가(로컬업로드) ON
            onAddLocal: true,
            // (bool) URL추가 ON
            onAddUrl: true,
        };
        _.assignIn(defaults, this.defaultSettings);
        //console.log(defaults);

        return {
            // (string) 로컬스토리지 키값
            localStorageKey: 'uploader-settings/', // 해당 PC에 계정상관없이 설정공유됨.

            // (object) 기본값
            defaults: _.assignIn({}, defaults),

            // (object) 설정정보
            settings: _.assignIn({}, defaults),

            // (object) 수정정보
            editedSettings: _.assignIn({}, defaults),
        };
    },
    computed: {
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        /**
         * 세팅창 실행
         */
        openSettingModal() {
            // 세팅값 적용
            _.assignIn(this.editedSettings, this.settings);


            // 모달창 이벤트등록
            UIkit.util.once(this.$refs.modal, 'shown', () => {
            });
            UIkit.modal(this.$refs.modal).show();
        },

        /**
         * 세팅창 종료
         */
        closeSettingModal() {
            // 모달창 종료
            UIkit.util.once(this.$refs.modal, 'hidden', () => {
            });
            UIkit.modal(this.$refs.modal).hide();
        },

        /**
         * 저장
         */
        save() {
            //console.log(this.editedSettings);
            //console.log(JSON.stringify(this.editedSettings));
            localStorage.setItem(this.localStorageKey, JSON.stringify(this.editedSettings));
            this.setSettings(this.editedSettings);
            this.closeSettingModal();
        },


        /**
         * 세팅정보를 로컬스토리지에서 읽어온다.
         * 저장된값이 없다면 초기화 처리해준다.
         *
         */
        loadSettings() {
            // 로컬스토리지 값
            let localSettings = localStorage.getItem(this.localStorageKey);
            if (localSettings) {
                localSettings = JSON.parse(localSettings);
            } else {
                localSettings = {};
            }

            // 기본값 병합처리
            this.setSettings(_.assignIn({}, this.defaults, localSettings));

        },

        /**
         * 설정값을변경
         */
        setSettings(settings) {
            this.settings = _.assignIn({}, settings);
            // 이벤트
            this.$emit('changed', this.settings);
        },
    },
}
</script>

<style lang="scss" scoped>

.root {
    display: inline-block;
}

.setting-button {
    color: #1F2B3D;
    font-size: 2rem;
}

.uk-checkbox {
    width: 20px;
    height: 20px;
}

label {
    display: block;
}
</style>